import { render } from "./DojoSettingsTab.vue?vue&type=template&id=c0bf23ae&scoped=true"
import script from "./DojoSettingsTab.vue?vue&type=script&lang=js"
export * from "./DojoSettingsTab.vue?vue&type=script&lang=js"

import "./DojoSettingsTab.vue?vue&type=style&index=0&id=c0bf23ae&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bf23ae"]])

export default __exports__